import React, { Component } from 'react';
import Dico from '../../helpers/Dico';

class CalculatorRegularPayment extends Component {
    render() {
        return (
            <React.Fragment>
                <h6>{Dico.getMessage(this.props.context.countryCode, this.props.context.languageCode, 'calculatorPage.result.title')}</h6>
                <h4>
                    {this.props.isCalculationResult
                        && this.props.calculationResponse.result.teaser.regularPayment
                        && Dico.getTextWithArguments(this.props.calculationResponse.result.teaser.regularPayment,
                            this.props.calculationResponse.result.teaser.data, this.props.amountNature,
                            this.props.context.countryCode, this.props.context.languageCode,
                            this.props.calculationResponse.result.teaser.guide
                        )}
                </h4>
                <div>
                    <button className='btn btn-primary' onClick={this.props.onUpdateCriteria} data-bs-dismiss="modal">
                        {Dico.getMessage(this.props.context.countryCode, this.props.context.languageCode, 'calculatorPage.action.select')}
                    </button>
                </div>
            </React.Fragment>
        );
    }
}

export default (CalculatorRegularPayment)
